<template>
    <div style="height: 100%">
        <div name="result_table" class="table-layout">
            <el-table class="thin" :data="pageDevcDefImpList" :height="tableHeight" ref="scrapImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange"
                      :row-class-name="markSelectedRowClassName">
                <!--<el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>-->
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="checkFailMsg" label="检查结果信息" width="200" align="left" fixed="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.checkFailMsg == null || rows.row.checkFailMsg == ''">成功</span>
                        <span class="font-red" v-else>{{ rows.row.checkFailMsg || '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属业务单元">
                    <el-table-column prop="comName" width="180" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="报废部门" prop="departName" width="120"></el-table-column>
                <el-table-column label="报废人">
                    <!--:render-header="setBathPrincipal"-->
                    <el-table-column prop="staffName" width="120">
                        <template slot-scope="rows">
                            <span>{{ rows.row.staffName }}</span>
                            <!--<a class="swb-btn-link fr inline-block" @click="setPrincipal(rows.row)">设置</a>-->
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产编号">
                    <el-table-column prop="innerCode" width="160" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="系统编号">
                    <el-table-column prop="tmpNo" width="200" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="外部系统编号">
                    <el-table-column prop="innerNo" width="160" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="管理方式">
                    <el-table-column prop="assetType" width="100" align="center" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产描述全称">
                    <el-table-column prop="title" width="200" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="控制方式">
                    <el-table-column align="center" prop="splitible" width="100">
                        <template slot-scope="rows">
                            <span>{{ rows.row.splitible ? '按金额' : '按数量' }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="可报废数量">
                    <el-table-column align="right" prop="scrapMaxQuantity" width="100">
                        <template slot-scope="rows">
                            <span>{{ rows.row.scrapMaxQuantity || 0 }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="报废数量">
                    <el-table-column align="right" prop="quantity" width="100">
                        <template slot-scope="rows">
                            <el-input class="text-right" type="number" min="1" :disabled="rows.row.assetType == 0 || rows.row.splitible" v-model="rows.row.quantity" @change="changeQuantity(rows.row)"></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column align="right" prop="orgWorthKz" width="80" label="资产原值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.orgWorthKz != null">{{ rows.row.orgWorthKz.toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="netWorthKz" width="80" label="资产净值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.netWorthKz != null">{{ rows.row.netWorthKz.toFixed(2) }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" prop="splittedAmount" width="120" label="报废原值(元)">
                    <template slot-scope="rows">
                        <el-input :disabled="rows.row.assetType == 0 || !rows.row.splitible" class="text-right" type="number" min="0" v-model="rows.row.splittedAmount" @change="changeSplittedAmount(rows.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="netWorth" width="80" label="报废损失金额(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="deprTiming" width="100" label="报废时效类型">
                    <template slot-scope="rows">
                        <span v-if="rows.row.deprTiming != null">{{ scrapDeprTimingMap[rows.row.deprTiming] }}</span>
                    </template>
                </el-table-column>

                <el-table-column align="left" prop="scrapCause" width="160" label="报废原因">
                    <template slot-scope="rows">
                        <el-select v-model="rows.row.scrapCause" placeholder="请选择">
                            <el-option v-for="item in devcScrapCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <!--<el-table-column align="right" width="150" label="清理费用" v-show="fiscalClearFlag">-->
                <!--<template slot-scope="rows">-->
                <!--&lt;!&ndash;<el-form-item :prop="'itemList.' + rows.$index + '.theFee'" :rules="{validator: checkMoneyStr, trigger: 'blur'}">&ndash;&gt;-->
                <!--<el-input class="input-content-left" type="text" v-model="rows.row.theFee"></el-input>-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="right" width="150" label="清理收入" v-show="fiscalClearFlag">-->
                <!--<template slot-scope="rows">-->
                <!--&lt;!&ndash;<el-form-item :prop="'itemList.' + rows.$index + '.theInc'" :rules="{validator: checkMoneyStr, trigger: 'blur'}">&ndash;&gt;-->
                <!--<el-input class="input-content-left" type="text" v-model="rows.row.theInc"></el-input>-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column align="left" width="100" label="操作">
                    <template slot-scope="rows">
                        <span class="swb-bth swb-btn-link" @click="removeScrapItem(rows.$index)">移除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix" name="pagination">
            <el-pagination background class="fl mt5" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateModel(true)">检查</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="deviceImpIn">导入</div>
        </div>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'
import { openComStaffComnSelectDlg } from '../orgStruct/selectDlg'
import { getMerchantBizParam } from '../asset/assetMain'

import assetVchrApi from '../../api/assetVchr'

export default {
    name: 'swb-shop-devc-scrap-voucher-imp-check',
    desc: '资产报废导入检查',
    props: ['fileExtra'],
    data: function () {
        return {
            tableHeight: 500,
            pageNumber: 1,
            totalCount: 0,
            pageSizze: null,
            pageSizes: [10, 50, 100, 200],// 特殊页面处理
            multipleSelection: [],
            max_quantity_per_item: 200,
            //
            nextIndex: 0,
            checkNextIndex: 0,
            startIndex: 0,
            checkSuccess: false,    // 是否已经检查通过
            //
            applyTitleMap: {},  // {机构Id： 标题}
            applyDescMap: {},   // {机构Id： 申请原因}
            scrapImpInfoList: [],// 报废的资产列表
            pageDevcDefImpList: [],
            //
            voucherMap: {}, // 已生成的报废单
            devcScrapCauseList: [],
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            scrapDeprTimingMap: getEnumMap('scrapDeprTiming', 'value2text')
        }
    },
    watch: {},
    created: function () {
        let self = this;
        this.pageSize = this.pageSizes.first();
        //
        let devcScrapCauseList = getEnumList('devcScrapCause');
        let scrapCauseList = [];
        devcScrapCauseList.forEach(function (item) {
            if(item.value != 9) {
                scrapCauseList.push(item);
            }
        });
        this.devcScrapCauseList = scrapCauseList;
        //
        let fileExtra = this.fileExtra || {};
        this.applyTitleMap = fileExtra.applyTitleMap || null;
        this.applyDescMap = fileExtra.applyDescMap || null;
        this.scrapImpInfoList = fileExtra.scrapImpInfoList || [];
        //
        // 报废审核通过后自动执行清理/清除： {Boolean}//零售商
        getMerchantBizParam('auto.fiscal.clear.after.scrap.audit.approved', function (result) {
            self.fiscalClearFlag = Utils.isTrue(result);
        });
        // 先检查并补充资产数据
        this.validateModel(true);
        // 分页处理
        // this.setPageDevcDefImpInfoList();

        // this.getCurrUserInfo();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.tableHeight = height;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('[name="pagination"]'));
        domSizeWatcher.start(500);
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        checkMoneyStr: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入正确的金额'));
                } else {
                    callback();
                }
            }
        },
        changeQuantity: function (scrapItem) {
            let maxQuantity = scrapItem.scrapMaxQuantity;
            //
            let quantity = parseInt(scrapItem.quantity);
            if(quantity > maxQuantity) {
                scrapItem.quantity = maxQuantity;
                Toast.show(scrapItem.title + '报废数量不能超过可报废数量:' + maxQuantity);
            }
            //
            scrapItem.splittedAmount = ((parseFloat(scrapItem.orgWorthKz) / maxQuantity) * scrapItem.quantity).toFixed(2);
            //  计算-报废损失金额
            let params = [{
                splittedAmount: scrapItem.splittedAmount,
                deviceXId: scrapItem.deviceXId,
                tmpNo: scrapItem.tmpNo,
                assetType: scrapItem.assetType
            }];
            this.getScrapVoucherItemNetWorth(params, function (netWorthMaps) {
                scrapItem.netWorth = netWorthMaps[scrapItem.deviceXId];
            });
        },
        changeSplittedAmount: function (scrapItem) {
            let splittedAmount = parseFloat(scrapItem.splittedAmount);
            //
            let orgWorthKz = parseFloat(scrapItem.orgWorthKz || 0);
            if(splittedAmount > orgWorthKz) {
                scrapItem.splittedAmount = scrapItem.orgWorthKz;
                Toast.show(scrapItem.title + '报废损失金额不能大于原值:' + orgWorthKz);
            }
            scrapItem.splittedAmount = Utils.isNoB(scrapItem.splittedAmount) ? '0.00' : scrapItem.splittedAmount.toFixed(2);
            //  计算-报废损失金额
            let params = [{
                splittedAmount: scrapItem.splittedAmount,
                deviceXId: scrapItem.deviceXId,
                tmpNo: scrapItem.tmpNo,
                assetType: scrapItem.assetType
            }];
            this.getScrapVoucherItemNetWorth(params, function (netWorthMaps) {
                scrapItem.netWorth = netWorthMaps[scrapItem.deviceXId];
            });
        },
        getScrapVoucherItemNetWorth: function (params, callbackFunc) {
            let loading = MsgBox.loading();
            assetVchrApi.getShopDeviceScrapVoucherItemNetWorth(params, function (result) {
                loading.close();
                if(result.type == 'info') {
                    //
                    callbackFunc(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getCurrUserInfo() {
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    self.scopeId = result.data.scopeEntity.scopeId;
                }
            });
        },
        markSelectedRowClassName(row) {
            return this.multipleSelection.find(function (tmpRow) {
                return tmpRow.rowNo == row.rowNo;
            }) != null ? 'selected-row' : '';
        },
        //
        setPageDevcDefImpInfoList: function () {
            let totalRows = this.scrapImpInfoList || [];
            let start = (this.pageNumber - 1) * this.pageSize;
            let end = this.pageNumber * this.pageSize;
            if(totalRows.length != 0 && start > (totalRows.length - 1)) {
                this.pageNumber = this.pageNumber - 1;
                start = (this.pageNumber - 1) * this.pageSize;
                end = this.pageNumber * this.pageSize;
            }
            this.startIndex = start;
            this.pageDevcDefImpList = totalRows.slice(start, end);
            this.totalCount = totalRows.length;
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.handlePageChange(1);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.setPageDevcDefImpInfoList();
        },
        removeScrapItem: function (theIndex) {
            let self = this;
            theIndex = this.startIndex + theIndex;
            //
            let scrapImpInfoList = this.scrapImpInfoList || [];
            scrapImpInfoList.splice(theIndex, 1);
            this.scrapImpInfoList = Utils.merge([], scrapImpInfoList);
            // 如果移除是未检查通过的，需要重新检查是否全部通过。
            if(!Utils.isTrue(self.checkSuccess)) {
                let length = scrapImpInfoList.length;
                self.checkSuccess = true;
                for(let i = 0; i < length; i++) {
                    if(!Utils.isNoB(scrapImpInfoList[i].checkFailMsg)) {
                        self.checkSuccess = false;
                        break;
                    }
                }
            }
            //
            this.setPageDevcDefImpInfoList();
        },
        validateModel: function (isFirst) {
            if(isFirst) {  // 默认：检查通过
                this.checkSuccess = true;
            }
            if(this.scrapImpInfoList.length > this.max_quantity_per_item) {
                this.validateScrapImpModel(isFirst);
            } else {
                this.validateScrapImpModelList();
            }
        },
        // 逐条检查
        validateScrapImpModel: function (isFirst) {
            this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
            let self = this;
            let srcDevcDefImpInfoList = this.scrapImpInfoList || [];
            let srcListLength = srcDevcDefImpInfoList.length;
            console.log(srcListLength);
            //
            let checkNextIndex = this.checkNextIndex;
            let srcImpInfo = srcDevcDefImpInfoList[checkNextIndex];
            let impInfoList = [srcImpInfo];
            let theLoading = MsgBox.loading('【源件行号：' + srcImpInfo.rowNo + '】正在处理，请稍后...');
            assetVchrApi.doScrapVoucherImpCheck(impInfoList, function (result) {
                theLoading.hide();
                if(result.type != 'info') {
                    self.checkSuccess = false;
                    MsgBox.warning(result.message);
                    return;
                }
                let callItem = result.data[0];
                if(!Utils.isNoB(callItem.checkFailMsg) && self.checkSuccess) {
                    self.checkSuccess = false;
                }
                callItem.splittedAmount = Utils.isNoB(callItem.splittedAmount) ? '0.00' : callItem.splittedAmount.toFixed(2);
                srcDevcDefImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                self.scrapImpInfoList = Utils.merge([], srcDevcDefImpInfoList);
                self.checkData();
                //
                let pageSize = self.pageSize;
                let pageNumber = (checkNextIndex + 1) / pageSize;
                let pageNumber2 = (checkNextIndex + 1) % pageSize;
                if(pageNumber2 != 0) {
                    pageNumber = pageNumber + 1;
                }
                self.handlePageChange(pageNumber);
                //
                if(checkNextIndex < srcListLength - 1) {
                    self.checkNextIndex += 1;
                    self.validateScrapImpModel(false);
                } else {
                    self.handlePageChange(1);
                }
            });
        },
        // 小于500 直接检查
        validateScrapImpModelList: function () {
            let self = this;
            let impInfoList = this.scrapImpInfoList || [];
            //
            let theLoading = MsgBox.loading('正在处理检查，请稍后...');
            assetVchrApi.doScrapVoucherImpCheck(impInfoList, function (result) {
                theLoading.hide();
                if(result.type != 'info') {
                    self.checkSuccess = false;
                    MsgBox.warning(result.message);
                    return;
                }
                let callItemList = result.data || [];
                for(let i = 0; i < callItemList.length; i++) {
                    callItemList[i].splittedAmount = Utils.isNoB(callItemList[i].splittedAmount) ? '0.00' : callItemList[i].splittedAmount.toFixed(2);
                    if(!Utils.isNoB(callItemList[i].checkFailMsg)) {
                        self.checkSuccess = false;
                        break;
                    }
                }
                self.scrapImpInfoList = Utils.merge([], callItemList);
                //
                self.checkData();
            });
        },
        checkData: function () {
            let self = this;
            //记录被选中的行
            let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
            //
            this.scrapImpInfoList = this.scrapImpInfoList.clone();
            this.setPageDevcDefImpInfoList();
            //（必须）延迟恢复被选中的行
            setTimeout(function () {
                self.scrapImpInfoList.forEach(function (row) {
                    if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                        self.$refs.scrapImpInfoTable.toggleRowSelection(row);
                    }
                });
            }, 1000);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //
        deviceImpIn() {
            let self = this;
            if(!self.checkSuccess) {    // 检查是否已通过
                MsgBox.warning('存在未处理的异常数据，请先检查后再执行导入');
                return;
            }
            let impInfoList = this.scrapImpInfoList || [];
            let srcListLength = impInfoList.length;
            if(srcListLength > 500) {
                //弹出确认框
                this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    self.doScrapImportStart();
                }).catch(function () {

                });
            } else {
                self.doScrapImportStart();
            }
        },
        doScrapImportStart() {
            let self = this;
            let nextIndex = this.nextIndex;
            let impInfoList = this.scrapImpInfoList || [];
            let srcListLength = impInfoList.length;
            let srcImpInfo = impInfoList[nextIndex];
            // 记录单据分组，条件： comId + warehouseId， 同机构，同仓库的为一个报废单
            let voucherMap = this.voucherMap;
            let currentKey = srcImpInfo.comId + '_' + srcImpInfo.warehouseId;
            let voucherNo = voucherMap[currentKey];
            //
            let postData = {
                no: voucherNo || null,
                comId: srcImpInfo.comId,
                WarehouseId: srcImpInfo.warehouseId,
                applyDesc: self.applyDescMap[srcImpInfo.comId + ''],
                digest: self.applyTitleMap[srcImpInfo.comId + ''],
                itemList: [srcImpInfo],
            };
            let theLoading = MsgBox.loading('【源件行号：' + srcImpInfo.rowNo + '】正在处理，请稍后...');
            assetVchrApi.saveScrapVoucherImpDo(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    if(Utils.isNoB(voucherNo)) {       // 记录单据号
                        voucherMap[currentKey] = result.data;
                    }
                } else {
                    self.checkSuccess = false;
                    srcImpInfo.checkFailMsg = result.message;
                }
                //
                let pageSize = self.pageSize;
                let pageNumber = (nextIndex + 1) / pageSize;
                let pageNumber2 = (nextIndex + 1) % pageSize;
                if(pageNumber2 != 0) {
                    pageNumber = pageNumber + 1;
                }
                self.handlePageChange(pageNumber);
                //
                if(nextIndex < (srcListLength - 1)) {
                    self.nextIndex = nextIndex + 1;
                    self.doScrapImportStart();
                } else {
                    if(self.checkSuccess) {
                        self.$emit('other-close');
                    }
                }
            });
        }
    }
}
</script>

<style>
.el-table .selected-row {
    background: #c9e5f5;
}
</style>



// WEBPACK FOOTER //
// src/compo/scrapVoucher/ScrapVoucherImpCheck.vue